import { useRef, useState } from "react";

export function useMessageController() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const timeoutRef = useRef<NodeJS.Timeout>();
  const closeMessage = () => {
    setOpen(false);
    setMessage("");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  };
  const showMessage = ({
    message,
    timeoutMs,
  }: {
    message: string;
    timeoutMs: number;
  }) => {
    setMessage(message);
    setOpen(true);
    timeoutRef.current = setTimeout(closeMessage, timeoutMs);
  };

  return {
    closeMessage,
    showMessage,
    open,
    message,
  };
}
